import {
  getIsAuthenticated,
  getIsUnderReview,
} from 'ha/modules/AuthLogic/selectors';
import HttpStatus from 'ha/constants/HttpStatus';

const onEnterMy = store => ({ location }, replace) => {
  if (!getIsAuthenticated(store.getState())) {
    replace({
      ...location,
      pathname: '/login',
      query: {
        return_url: `${location.pathname}${location.search}`,
      },
      state: {
        redirectCode: HttpStatus.FOUND_REDIRECTION,
      },
    });
  }

  if (getIsUnderReview(store.getState())) {
    replace({
      ...location,
      pathname: '/under-review',
      query: {},
      search: '',
      state: {
        redirectCode: HttpStatus.FOUND_REDIRECTION,
      },
    });
  }
};

export default onEnterMy;
